import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/page-header";
import { getProfile } from "@/lib/api/profile";
import { useSession } from "@/lib/auth-client";
import { useTrustDeviceStatus } from "@/lib/hooks/use-security";
import { useT } from "@/lib/i18n/use-t";
import { McpInfoSection } from "./mcp-info-section";
import { OAuthAppsSection } from "./oauth-apps-section";
import { T } from "./page.i18n";
import { SessionManagement } from "./session-management";
import { TwoFactorSetup } from "./two-factor-setup";

export default function SecuritySettingsPage() {
  const t = useT(T);
  const { data: sessionData } = useSession();

  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: getProfile,
  });

  const mcpUrl = `${process.env.BUN_PUBLIC_API_URL}/api/mcp`;

  const { data: trustData } = useTrustDeviceStatus();
  const isTrusted = trustData?.isTrusted ?? false;

  return (
    <div className="space-y-6">
      <PageHeader title={t.securitySettings} description={t.description} />

      {profile && !profile.isSsoUser && (
        <TwoFactorSetup
          twoFactorEnabled={profile?.twoFactorEnabled ?? false}
          phoneNumber={profile?.phoneNumber}
        />
      )}

      {sessionData?.session && (
        <SessionManagement
          currentSessionId={sessionData.session.id}
          isTrusted={isTrusted}
          twoFactorEnabled={profile?.twoFactorEnabled ?? false}
        />
      )}

      <McpInfoSection mcpUrl={mcpUrl} />

      <OAuthAppsSection />
    </div>
  );
}
